// Floor plan furniture/fixture asset catalog
// All dimensions in inches

const ASSET_CATEGORIES = {
  bedroom: {
    label: 'Bedroom',
    icon: 'bi-lamp',
    items: [
      { id: 'bed_twin', name: 'Twin Bed', width: 39, depth: 75, color: '#B0C4DE' },
      { id: 'bed_full', name: 'Full Bed', width: 54, depth: 75, color: '#B0C4DE' },
      { id: 'bed_queen', name: 'Queen Bed', width: 60, depth: 80, color: '#B0C4DE' },
      { id: 'bed_king', name: 'King Bed', width: 76, depth: 80, color: '#B0C4DE' },
      { id: 'nightstand', name: 'Nightstand', width: 24, depth: 18, color: '#DEB887' },
      { id: 'dresser', name: 'Dresser', width: 60, depth: 18, color: '#DEB887' },
      { id: 'wardrobe', name: 'Wardrobe', width: 48, depth: 24, color: '#DEB887' },
    ],
  },
  living: {
    label: 'Living Room',
    icon: 'bi-house',
    items: [
      { id: 'sofa_2seat', name: '2-Seat Sofa', width: 60, depth: 34, color: '#778899' },
      { id: 'sofa_3seat', name: '3-Seat Sofa', width: 84, depth: 36, color: '#778899' },
      { id: 'sofa_sectional', name: 'Sectional', width: 100, depth: 84, color: '#778899' },
      { id: 'armchair', name: 'Armchair', width: 34, depth: 34, color: '#778899' },
      { id: 'coffee_table', name: 'Coffee Table', width: 48, depth: 24, color: '#DEB887' },
      { id: 'tv_stand', name: 'TV Stand', width: 60, depth: 18, color: '#696969' },
      { id: 'bookshelf', name: 'Bookshelf', width: 36, depth: 12, color: '#DEB887' },
    ],
  },
  kitchen: {
    label: 'Kitchen',
    icon: 'bi-cup-hot',
    items: [
      { id: 'fridge', name: 'Refrigerator', width: 36, depth: 30, color: '#C0C0C0' },
      { id: 'stove', name: 'Stove/Oven', width: 30, depth: 26, color: '#C0C0C0' },
      { id: 'dishwasher', name: 'Dishwasher', width: 24, depth: 24, color: '#C0C0C0' },
      { id: 'sink_kitchen', name: 'Kitchen Sink', width: 33, depth: 22, color: '#ADD8E6' },
      { id: 'island', name: 'Kitchen Island', width: 72, depth: 36, color: '#DEB887' },
      { id: 'counter', name: 'Counter (4ft)', width: 48, depth: 25, color: '#DEB887' },
    ],
  },
  bathroom: {
    label: 'Bathroom',
    icon: 'bi-droplet',
    items: [
      { id: 'toilet', name: 'Toilet', width: 18, depth: 28, color: '#F5F5F5' },
      { id: 'bathtub', name: 'Bathtub', width: 30, depth: 60, color: '#F5F5F5' },
      { id: 'shower', name: 'Shower Stall', width: 36, depth: 36, color: '#ADD8E6' },
      { id: 'vanity_single', name: 'Single Vanity', width: 36, depth: 22, color: '#DEB887' },
      { id: 'vanity_double', name: 'Double Vanity', width: 60, depth: 22, color: '#DEB887' },
    ],
  },
  dining: {
    label: 'Dining',
    icon: 'bi-cup',
    items: [
      { id: 'dining_table_4', name: 'Dining Table (4)', width: 48, depth: 36, color: '#DEB887' },
      { id: 'dining_table_6', name: 'Dining Table (6)', width: 72, depth: 42, color: '#DEB887' },
      { id: 'dining_chair', name: 'Dining Chair', width: 18, depth: 20, color: '#BC8F8F' },
    ],
  },
  office: {
    label: 'Office',
    icon: 'bi-pc-display',
    items: [
      { id: 'desk', name: 'Desk', width: 60, depth: 30, color: '#DEB887' },
      { id: 'office_chair', name: 'Office Chair', width: 24, depth: 24, color: '#696969' },
      { id: 'filing_cabinet', name: 'Filing Cabinet', width: 18, depth: 24, color: '#C0C0C0' },
    ],
  },
  laundry: {
    label: 'Laundry',
    icon: 'bi-water',
    items: [
      { id: 'washer', name: 'Washer', width: 27, depth: 30, color: '#F5F5F5' },
      { id: 'dryer', name: 'Dryer', width: 27, depth: 30, color: '#F5F5F5' },
    ],
  },
  landscaping: {
    label: 'Landscaping',
    icon: 'bi-tree',
    items: [
      { id: 'tree_small', name: 'Small Tree', width: 48, depth: 48, color: '#228B22' },
      { id: 'tree_large', name: 'Large Tree', width: 96, depth: 96, color: '#006400' },
      { id: 'shrub', name: 'Shrub', width: 36, depth: 36, color: '#32CD32' },
      { id: 'hedge', name: 'Hedge (6ft)', width: 72, depth: 24, color: '#2E8B57' },
      { id: 'flower_bed', name: 'Flower Bed', width: 72, depth: 36, color: '#8FBC8F' },
      { id: 'planter_box', name: 'Planter Box', width: 36, depth: 18, color: '#DEB887' },
      { id: 'patio', name: 'Patio', width: 144, depth: 120, color: '#D2B48C' },
      { id: 'fire_pit', name: 'Fire Pit', width: 48, depth: 48, color: '#A0522D' },
      { id: 'fountain', name: 'Fountain', width: 48, depth: 48, color: '#ADD8E6' },
      { id: 'fence_section', name: 'Fence Section (8ft)', width: 96, depth: 6, color: '#8B7355' },
    ],
  },
  stairs: {
    label: 'Stairs',
    icon: 'bi-ladder',
    items: [
      { id: 'straight_stair', name: 'Straight Staircase', width: 36, depth: 120, color: '#BC8F8F' },
      { id: 'l_shaped_stair', name: 'L-Shaped Staircase', width: 72, depth: 96, color: '#BC8F8F' },
      { id: 'u_shaped_stair', name: 'U-Shaped Staircase', width: 72, depth: 120, color: '#BC8F8F' },
      { id: 'spiral_stair', name: 'Spiral Staircase', width: 60, depth: 60, color: '#BC8F8F' },
      { id: 'landing', name: 'Landing', width: 36, depth: 36, color: '#D2B48C' },
    ],
  },
};

/**
 * Get all asset categories
 */
export function getAssetCategories() {
  return ASSET_CATEGORIES;
}

/**
 * Get a specific asset by its ID
 */
export function getAssetById(assetId) {
  for (const category of Object.values(ASSET_CATEGORIES)) {
    const item = category.items.find(i => i.id === assetId);
    if (item) return item;
  }
  return null;
}

/**
 * Get all items flat
 */
export function getAllAssets() {
  const all = [];
  for (const category of Object.values(ASSET_CATEGORIES)) {
    all.push(...category.items);
  }
  return all;
}

export default ASSET_CATEGORIES;
